import { render, staticRenderFns } from "./ModuleFields.vue?vue&type=template&id=2ad76294"
import script from "./ModuleFields.vue?vue&type=script&lang=ts"
export * from "./ModuleFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports